<main class="page-shell auth-page">
  <section class="card reset-card">
    <h2>Reset your password</h2>
    <p class="hint">Enter a new password for your account.</p>

    <form *ngIf="hasToken" [formGroup]="form" (ngSubmit)="submit()" class="form">
      <label>
        New password
        <input type="password" formControlName="password" placeholder="New password" />
      </label>
      <label>
        Confirm password
        <input type="password" formControlName="confirm" placeholder="Confirm password" />
      </label>
      <button type="submit" class="btn-primary" [disabled]="isBusy">Update password</button>
    </form>

    <p class="message" *ngIf="message">{{ message }}</p>
    <p class="error" *ngIf="error">{{ error }}</p>
    <a routerLink="/auth" class="back">Back to login</a>
  </section>
</main>
